<ef-process-detail [process]="process$ | async"></ef-process-detail>
<!-- <ef-loading-container [observables]="[this.ratePlanningDataService.loading$]"></ef-loading-container> -->

<ef-rate-planning-presenter
[ratePlanning]="budgetWorksheet$ | async"
[fyeSelectItem]="fiscalYears$ | async"
(UpdateRatePlanning)="onUpdateRatePlanning($event)"
(LoadRatePlanning)="onLoadRatePlanning($event)"
(LoadCalcRates)="onLoadCalcRates($event)">
</ef-rate-planning-presenter>
